
    import { Vue, Component, Prop } from 'vue-property-decorator'
    import VueComponent from '../../node_modules/vue/types';
    import TrainingRecordDetailDTO from '../DTOs/TrainingRecordDetailDTO';
    import api from '../utils/api'
    import Option from '../models/Option'
    import DateTimeUtil from '../utils/DateTimeUtil'
    import { Sex } from '../models/Dog'
    import router from '../router';
    import DogHandlerTeam from '../models/DogHandlerTeam';
    import TrainingSearch from '../models/TrainingSearch'
    import TrainingSearchSubstance from '../models/TrainingSearchSubstance'
    import TrainingRecord from '../models/TrainingRecord'
    import CurrentUser from '../utils/CurrentUser';
    import Location from '../models/Location';
    import FileVM from '../viewmodels/FileVM';
    import FileHelper from '../utils/FileHelper';
    import MultiSelectUtil from '../utils/MultiSelectUtil';
    import $ from "jquery";
    import { Rules } from '../utils/Rules';

    @Component({
        name: 'TrainingRecord',
        beforeRouteLeave(to, from, next) {
            const self = this as any;
            // Check for unsaved changes
            let originalCompleted = self.TrainingRecord.Completed ? DateTimeUtil.splitDate(new Date(self.TrainingRecord.Completed)) : [null, null];
            let durationMinutes = DateTimeUtil.convertToMinutes(self.duration.Hours, self.duration.Minutes);

            if (!self.saveSubmitCancel && (self.OriginalTrainingRecord) && (
                (JSON.stringify(self.TrainingRecord) !== self.OriginalTrainingRecord) ||
                (originalCompleted[0] != self.date || originalCompleted[1] != self.time) ||
                (self.TrainingRecord.DurationMinutes != durationMinutes)
            )) {
                self.next = next;
                self.confirmLeaveModal = true;
            }
            else {
                next();
            }
        }
    })
    export default class TrainingRecordDetails extends Vue {
        @Prop(Number) id!: number;
        next: any;
        saveSubmitCancel = false;

        editMode: boolean = false;

        activePicker: any = null;
        date: Date | null | string = null;
        dateModal: boolean = false;
        timeModal: boolean = false;
        time: string | null = null;
        Sexes = [Sex.Male, Sex.Female];

        loadingData: boolean = false;
        savingData: boolean = false;
        uploadingFiles: boolean = false;
        showError: boolean = false;
        showErrorMessage: boolean = false;
        errorText: string = 'An error occurred';
        durationError: boolean = false;
        substanceError: boolean = false;
        showSaveSuccess: boolean = false;
        confirmDeleteModal: boolean = false;
        confirmArchiveRestoreModal: boolean = false;
        confirmDeleteFileModal: boolean = false;
        confirmLeaveModal: boolean = false;
        valid: boolean = true;
        showSignatureRequired: boolean = false;
        submittingTrainerSig: boolean = false;
        submittingHandlerSig: boolean = false;
        fab: boolean = false;
        fileForDeletion: FileVM | null = null;
        duration = {Hours: 0, Minutes: 0};
        weatherItems: number = 0;
        interferentItems: number[] = [];
        Rules: object = Rules;

        teamRequiredField: (Function)[] = [];
        numericField: (Function)[] = Rules.numericField;
        requiredField: (Function)[] = [];
        requiredFieldObj: (Function)[] = [];

        setFieldValidation(submitting: boolean) {
            this.teamRequiredField = submitting ? Rules.teamRequiredField : [];
            this.numericField = submitting ? Rules.requiredNumericField : Rules.numericField;
            this.requiredField = submitting ? Rules.requiredField : [];
            this.requiredFieldObj = submitting ? Rules.requiredFieldObj : [];
        }

        hours = [0];
        minutes = [0];

        headers = [
            { text: 'Name', value: 'Name', sortable: false },
            { text: 'File Type', value: 'FileType', sortable: false },
            { text: 'Uploaded', value: 'Uploaded', sortable: false },
            { text: '', value: 'Download', sortable: false, width: '6%' },
            { text: '', value: 'Delete', sortable: false, width: '6%' },
        ];

        // file-input only stores last added files
        lastAddedFiles: File[] = [];
        fileVMs: FileVM[] = [];

        selectedTrainingSearchFiles: FileVM[] | null = null;
        trainingSearchesLastAddedFiles: File[] = [];

        TrainingRecord: TrainingRecord = {
            ID: 0, Completed: undefined, Type: undefined, DogHandlerTeam: undefined,
            Trainer: undefined, Temperature: undefined, Weather: [], Goal: '', TrainerObservation: '', HandlerComment: '', TrainerApproved: null, HandlerApproved: null,
            TrainerSignatureUploaded: false, HandlerSignatureUploaded: false, IsDeleted: false, TrainingSearches: [], DevelopmentNeeds: '', Status: '', DurationMinutes: 0,
            Indication: undefined, Modified: null, ModifiedBy: null
        };

        OriginalTrainingRecord?: string;

        TrainingLocations: Location[] = [];
        TrainingTypes: Option[] = [];
        TrainingTasks: Option[] = [];
        TrainingIndications: Option[] = [];
        Substances: Option[] = [];
        SubstanceDetectionTypes: Option[] = [];
        SubstancePackaging: Option[] = [];
        SubstanceAmountUnitOptions: Option[] = [];
        SubstanceInterferentsOptions: Option[] = [];
        WeatherConditions: Option[] = [];
        AccreditationCompletion: number | null = null;

        trainerSignature: string = '';
        handlerSignature: string = '';

        trainingSearchToRemove: TrainingSearch | null = null;

        DogHandlerTeams: DogHandlerTeam[] = [];

        Exit() {
            this.next();
        }

        async created() {
            this.loadingData = true;
            for (let i = 1; i <= 8; i++) {this.hours.push(i)};
            for (let i = 5; i < 60; i = i + 5) {this.minutes.push(i)};

            let trainingRecordDetailResponse = await api.get<TrainingRecordDetailDTO>('Training/TrainingRecordDetail?id=' + this.id + '&userToken=' + CurrentUser.currentUserToken());

            if (trainingRecordDetailResponse.ok) {

                let responseData = trainingRecordDetailResponse.data;
                this.TrainingLocations = responseData!.LocationOptions;
                this.TrainingTypes = responseData!.TrainingTypeOptions;
                this.TrainingTasks = responseData!.TrainingTaskOptions;
                this.TrainingIndications = responseData!.TrainingIndicationOptions;
                this.Substances = responseData!.SubstanceOptions;
                this.SubstanceDetectionTypes = responseData!.SubstanceTypeOptions;
                this.SubstancePackaging = responseData!.SubstancePackagingOptions;
                this.SubstanceAmountUnitOptions = responseData!.SubstanceAmountUnitOptions;
                this.SubstanceInterferentsOptions = responseData!.SubstanceInterferentsOptions;
                this.WeatherConditions = responseData!.WeatherOptions;
                this.DogHandlerTeams = responseData!.DogHandlerTeams;
                if (responseData!.Documents) this.fileVMs = responseData!.Documents;

                if (responseData!.TrainingMinutesSinceAccreditation) this.AccreditationCompletion = responseData!.TrainingMinutesSinceAccreditation / (60);

                if (this.id != 0) {
                    this.TrainingRecord = responseData!.TrainingRecord;
                    if (this.TrainingRecord.Completed) {
                        //DateTime fields
                        [this.date, this.time] = DateTimeUtil.splitDate(new Date(this.TrainingRecord.Completed!));
                    }
                    if (this.TrainingRecord.DurationMinutes) {
                        //Duration fields
                        [this.duration.Hours, this.duration.Minutes] = DateTimeUtil.splitTimeMinutes(this.TrainingRecord.DurationMinutes!);
                    }
                }

                // Handlers can only view their own training records
                if (CurrentUser.currentUserRole() == "Handler" && this.TrainingRecord.DogHandlerTeam?.Handler.ID != CurrentUser.currentUserID()) {
                    this.$router.back();
                }

                this.editMode = CurrentUser.hasPermission('EditTrainingRecords') && (!this.TrainingRecord.Trainer || this.TrainingRecord.Trainer.ID == CurrentUser.currentUserID()) && !this.TrainingRecord.TrainerApproved && !this.TrainingRecord.IsDeleted;

                if (this.TrainingRecord.TrainerSignatureUploaded) { 
                    let trainerSignatureResponse = await api.getFile<any>('Training/GetSignature?TrainingRecordID=' + this.id + '&SignatureType=TrainerSignature' + '&userToken=' + CurrentUser.currentUserToken());

                    if (trainerSignatureResponse.ok) {
                        this.trainerSignature = URL.createObjectURL(trainerSignatureResponse.data!);
                    }
                    else {
                        // what should happen?
                        this.showError = true;
                    }
                }

                if (this.TrainingRecord.HandlerSignatureUploaded) {
                    let handlerSignatureResponse = await api.getFile<any>('Training/GetSignature?TrainingRecordID=' + this.id + '&SignatureType=HandlerSignature' + '&userToken=' + CurrentUser.currentUserToken());

                    if (handlerSignatureResponse.ok) {
                        this.handlerSignature = URL.createObjectURL(handlerSignatureResponse.data!);
                    }
                    else {
                        // what should happen?
                        this.showError = true;
                    }
                }

                this.OriginalTrainingRecord = JSON.stringify(this.TrainingRecord);
            }
            else {
                this.showError = true;
            }

            this.loadingData = false;
        }

        updateTrainingRecordIDs(returnedTrainingRecord: TrainingRecord) {
            for (var i = 0; i < this.TrainingRecord.TrainingSearches.length; i++) {
                this.TrainingRecord.TrainingSearches[i].ID = returnedTrainingRecord.TrainingSearches[i].ID;
            }

            this.TrainingRecord.ID = returnedTrainingRecord.ID;
        }

        async saveTrainingRecord() : Promise<boolean> {
            (this.$refs!.form! as any).resetValidation();

            // For some reason setTimeout is required for the validation to update
            let self = this;
            setTimeout(async function () {
                self.setFieldValidation(false);

                setTimeout(async function () {

                    (self.$refs!.form! as any).validate();

                    if (self.valid) {
                        self.savingData = true;
                        self.TrainingRecord.Completed = (self.date && self.time) ? DateTimeUtil.createDateTime(self.date! as string, self.time!) : undefined;
                        if (self.TrainingRecord.TrainerApproved) self.TrainingRecord.TrainerApproved = new Date(self.TrainingRecord.TrainerApproved!);
                        if (self.TrainingRecord.HandlerApproved) self.TrainingRecord.HandlerApproved = new Date(self.TrainingRecord.HandlerApproved!);
                        self.TrainingRecord.DurationMinutes = DateTimeUtil.convertToMinutes(self.duration.Hours, self.duration.Minutes);
                        let trainingRecordUploadResponse = await api.post<TrainingRecord>('Training/SaveTrainingRecord?userToken=' + CurrentUser.currentUserToken(), self.TrainingRecord);

                        if (trainingRecordUploadResponse.ok) {
                            self.updateTrainingRecordIDs(trainingRecordUploadResponse.data!);

                            // Upload files
                            self.uploadingFiles = true;
                            let addDeleteFilesResponse = await FileHelper.addDeleteFiles(self.fileVMs, "TBL_TrainingRecord", self.TrainingRecord.ID);
                            self.fileVMs = addDeleteFilesResponse.returnArray;

                            // Upload SD files
                            let addDeleteTrainingSearchesFiles = await FileHelper.addDeleteTrainingSearchesFiles(self.TrainingRecord.TrainingSearches);

                            self.TrainingRecord.TrainingSearches = addDeleteTrainingSearchesFiles.returnArray;

                            self.uploadingFiles = false;
                            self.showSaveSuccess = addDeleteFilesResponse.success && addDeleteTrainingSearchesFiles.success;

                            // Save Signatures
                            self.uploadSignature();

                            self.saveSubmitCancel = true;
                            self.$router.push('/TrainingRecords');
                        }
                        else {
                            self.showErrorMessage = true;
                            self.errorText = "Error: " + (trainingRecordUploadResponse.error ?? "Could not save Training Record");
                        }

                        self.savingData = false;
                    }
                    else {
                        self.scrollToInvalidField();
                    }
                });
            });
            return this.valid;
        }

        scrollToInvalidField() {
            this.$nextTick(() => {
                // Find first error message element
                var el = this.$el.querySelector(".v-messages.error--text:first-of-type");
                const yOffset = -200;

                if (!el) {
                    // Default to first non-disabled input
                    el = this.$el.querySelector(".v-input:not(.v-input--is-disabled):first-of-type");
                }

                const y = el!.getBoundingClientRect().top + window.pageYOffset + yOffset;                

                window.scrollTo({ top: y, behavior: 'smooth' });

                return;
            });
        }

        durationValidation(){
            if ((this.duration.Hours != 0 || this.duration.Minutes != 0) && !(this.duration.Hours == 8 && this.duration.Minutes > 0)){
                this.durationError = false;
            }
            else {
                this.durationError = true;
            }
        }

        otherValidation() {
            this.substanceError = false;
            this.TrainingRecord.TrainingSearches.forEach((ts) => {

                if (ts.SetupPositiveBlank == 'Positive' && ts.TrainingSearchSubstances.length == 0) {
                    ts.PositiveSetupError = true;
                    this.substanceError = true;
                }
                else {
                    ts.PositiveSetupError = false;
                }

                if (ts.TrainingSearchSubstances.length > 0) {
                    ts.TrainingSearchSubstances.forEach((s) => {
                        if (!s.Amount || !s.AmountUnit) {
                            s.AmountError = true;
                            this.substanceError = true;
                        }
                        else {
                            s.AmountError = false;
                        }
                    });
                }
            });
        }

        async uploadSignature() {
            if (CurrentUser.currentUserRole() == "Handler" && this.TrainingRecord.TrainerApproved) {
                if ((this.$refs.handlerSignaturePad! as any) && !(this.$refs.handlerSignaturePad! as any).isEmpty()) {
                    // save signature
                    this.savingData = true;
                    this.submittingHandlerSig = true;
                    // data is base64 string
                    var { isEmpty, data } = (this.$refs.handlerSignaturePad! as any).saveSignature();
                    let success = this.saveSignature(data, "HandlerSignature");
                }
            }
            else if (CurrentUser.currentUserRole() == "Admin") {
                if ((this.$refs.trainerSignaturePad! as any) && !(this.$refs.trainerSignaturePad! as any).isEmpty()) {
                    // save signature
                    this.savingData = true;
                    this.submittingTrainerSig = true;
                    // data is base64 string
                    var { isEmpty, data } = (this.$refs.trainerSignaturePad! as any).saveSignature();
                    let success = this.saveSignature(data, "TrainerSignature");
                }
            }
        }

        async submitTrainingRecord() {
            this.setFieldValidation(true);            
            this.durationValidation();
            this.otherValidation();

            let self = this;

            // For some reason setTimeout is required for the validation to update
            setTimeout(function () {
                (self.$refs!.form! as any).validate();

                // If approving as Handler and record is trainer approved then skip validation as there may be new required fields added since trainer approval 
                // which now can't be entered but the record should still be valid
                if ((self.valid && !self.durationError && !self.substanceError) || self.TrainingRecord.TrainerApproved) {
                    // check for signature
                    if (CurrentUser.currentUserRole() == "Handler") {
                        if (self.TrainingRecord.TrainerApproved) {
                            if (!self.TrainingRecord.HandlerSignatureUploaded && (self.$refs.handlerSignaturePad! as any).isEmpty()) {
                                self.showSignatureRequired = true;
                            }
                            else {
                                // save
                                self.savingData = true;

                                self.TrainingRecord.HandlerApproved = new Date();
                                self.saveTrainingRecord();
                            }
                        }
                        else {
                            // Shouldnt have been enabled
                        }
                    }
                    else if (CurrentUser.currentUserRole() == "Admin") {
                        if (!self.TrainingRecord.TrainerSignatureUploaded && (self.$refs.trainerSignaturePad! as any).isEmpty()) {
                            self.showSignatureRequired = true;
                        }
                        else {
                            // save
                            self.savingData = true;

                            self.TrainingRecord.TrainerApproved = new Date();
                            self.saveTrainingRecord();
                        }
                    }
                }
                else {
                    self.scrollToInvalidField();
                }
            });
        }

        setupPositiveBlankChanged(e: TrainingSearch) {
            // reset fields
            if (e.SetupPositiveBlank == 'Blank') {
                e.SetupVisualHidden = '';

                /*e.TrainingSearchSubstances = [];*/

                //e.Interferents = undefined;
                //e.SoakTime = undefined;
                //e.SearchTime = undefined;
            }
        }

        async saveSignature(file: string, signatureType: string): Promise<boolean> {

            let signatureUploadResponse = await api.post<null>('Training/UploadSignature?userToken=' + CurrentUser.currentUserToken(), { FileBase64string: file, TrainingRecordID: this.TrainingRecord.ID, FileName: signatureType + ".png" });

            return signatureUploadResponse.ok;
        }

        addNewTrainingSearch() {
            let newSearch: TrainingSearch = {
                ID: 0, Location: undefined, Task: undefined, Documents: [],
                SetupKnownBlind: '', SetupOnOffLead: '', SetupPositiveBlank: '', SetupVisualHidden: '', PositiveSetupError: false,
                TrainingSearchSubstances: [],
            };

            this.TrainingRecord.TrainingSearches.push(newSearch);
        }

        addNewSearchSubstance(trainingSearch: TrainingSearch) {
            let newSearchSubstance: TrainingSearchSubstance = {
                ID: 0, Substance: undefined, Amount: undefined, AmountUnit: undefined, Packaging: undefined, Type: undefined, HideLocation: '', AtHeight: false, AmountError: false
            }
            trainingSearch.TrainingSearchSubstances.push(newSearchSubstance);
        }

        removeSearchSubstance(trainingSearch: TrainingSearch, trainingSearchSubstance: TrainingSearchSubstance) {
            const index = trainingSearch.TrainingSearchSubstances.indexOf(trainingSearchSubstance);
            if (index > -1) {
                trainingSearch.TrainingSearchSubstances.splice(index, 1);
            }
        }

        removeTrainingSearch(trainingSearch: TrainingSearch) {
            this.confirmDeleteModal = true;
            this.trainingSearchToRemove = trainingSearch;
        }

        confirmRemoveTrainingSearch() {
            if (this.trainingSearchToRemove) {

                const index = this.TrainingRecord.TrainingSearches.indexOf(this.trainingSearchToRemove);
                if (index > -1) {
                    this.TrainingRecord.TrainingSearches.splice(index, 1);
                }
                this.trainingSearchToRemove = null;
            }

            this.confirmDeleteModal = false;
        }

        undoTrainerSig() {
            (this.$refs.trainerSignaturePad! as any).undoSignature();
        }

        undoHandlerSig() {
            (this.$refs.handlerSignaturePad! as any).undoSignature();
        }

        decodeHtml(html: string) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        }

        async archiveRestoreRecord() {
            this.savingData = true;
            this.TrainingRecord.IsDeleted = !this.TrainingRecord.IsDeleted;
            let trainingRecordUploadResponse = await api.post<null>('Training/SaveTrainingRecord?userToken=' + CurrentUser.currentUserToken(), this.TrainingRecord);

            if (trainingRecordUploadResponse.ok) {
                this.showSaveSuccess = true;
            }
            else {
                this.showErrorMessage = true;
                this.errorText = "Error: " + (trainingRecordUploadResponse.error ?? "Could not archive Training Record");
            }
            this.savingData = false;
            this.confirmArchiveRestoreModal = false;
            this.editMode = CurrentUser.hasPermission('EditTrainingRecords') && !this.TrainingRecord.TrainerApproved && !this.TrainingRecord.IsDeleted;
        }

        goBack() {
            this.saveSubmitCancel = true;
            router.back();
        }

        onScroll(e: any) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset || e.target.scrollTop || 0
            this.fab = top > 20
        }

        toTop() {
            this.$vuetify.goTo(0);
        }

        addFile() {
            for (let i = 0; i < this.lastAddedFiles.length; i++) {
                let file = (this.lastAddedFiles[i] as File);
                this.fileVMs.push({ ID: 0, Name: file.name, FileType: file.type.split('/').pop() || '', Uploaded: new Date, ExternalFileName: '', InternalFileName: '', IsDeleted: false, File: file });
            }
        }

        confirmDeleteFile(file: FileVM) {
            this.fileForDeletion = file;
            this.confirmDeleteFileModal = true;
        }

        async downloadFile(fileInfo: FileVM) {
            let file = await api.DownloadFile(fileInfo.ID);
            if (file) {
                const link = document.createElement('a');
                link.href = file;
                link.download = fileInfo.ExternalFileName;
                link.click();
            }
            else {
                this.showErrorMessage = true;
                this.errorText = "Error: Could not download file";
            }
        }

        async deleteFile() {
            let fileInfo = this.fileForDeletion;
            if (fileInfo) {
                fileInfo.IsDeleted = true;
            }
            this.confirmDeleteFileModal = false;
        }

        addTrainingSearchFileClick(trainingSearchFiles: FileVM[]) {
            // Store the specific training search files view model so we know which SD to store the files against when they are uploaded
            this.selectedTrainingSearchFiles = trainingSearchFiles;
            
            (this.$refs.TrainingSearchDocumentUpload! as any).$refs.input.click();
        }

        addTrainingSearchFile() {
            if (this.selectedTrainingSearchFiles) {
                for (let i = 0; i < this.trainingSearchesLastAddedFiles.length; i++) {
                    let file = (this.trainingSearchesLastAddedFiles[i] as File);
                    this.selectedTrainingSearchFiles.push({ ID: 0, Name: file.name, FileType: file.type.split('/').pop() || '', Uploaded: new Date, ExternalFileName: '', InternalFileName: '', IsDeleted: false, File: file });
                }
            }
        }

        isTrainer() : boolean {
            return CurrentUser.currentUserRole() == "Admin";
        }

        isHandler() : boolean {
            return CurrentUser.currentUserRole() == "Handler";
        }

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.detectResizeForMultiSelects);
                window.addEventListener('load', this.detectResizeForMultiSelects);
            });
        }

        updated() {
            this.detectResizeForMultiSelects();
        }

        detectResizeForMultiSelects() {
            if (this.$refs.weatherMultiSelect) {
                this.weatherItems = MultiSelectUtil.numberOfItems(this.$refs.weatherMultiSelect);
            }

            if (this.TrainingRecord.TrainingSearches.length > 0) {
                for (let i = 0; i < this.TrainingRecord.TrainingSearches.length; i++) {                    
                    if ((this.$refs['interferentMultiSelect' + i] as VueComponent[])) {
                        this.interferentItems[i] = MultiSelectUtil.numberOfItems((this.$refs['interferentMultiSelect' + i] as VueComponent[])[0]);
                    }
                }

                // In order for interferentItem array to be reactive in Vue you need to Vue.set the data
                let copy = this.interferentItems;
                this.interferentItems = [];
                Vue.set(this, 'interferentItems', copy);
            }
        }

        checkPermission(permission: string) {
            return CurrentUser.hasPermission(permission);
        }
    }
